import { useEffect } from 'react';

/** Викликає onRefresh при зміні listRefreshNonce (nonce > 0). */
export function useListRefreshEffect(listRefreshNonce: number, onRefresh: () => void) {
    useEffect(() => {
        if (!listRefreshNonce) return;
        onRefresh();
    }, [listRefreshNonce]);
}
